import type { IconProps } from "./types";

export const Picture = ({ ref, color = "currentColor", ...props }: IconProps) => {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.333 4.167c0-.46.373-.834.834-.834h11.666c.46 0 .834.374.834.834v6.321l-2.744-2.744a.833.833 0 00-1.179 0l-8.87 8.87a.834.834 0 01-.54-.78V4.166zm.835 14.166h-.001zm0 0h11.665a2.5 2.5 0 002.5-2.5v-3.332V4.167a2.5 2.5 0 00-2.5-2.5H4.167a2.5 2.5 0 00-2.5 2.5v11.666a2.5 2.5 0 002.499 2.5m12.5-5.488v2.988c0 .46-.372.834-.833.834H6.178l7.155-7.155 3.334 3.333zM7.084 6.667a.417.417 0 100 .833.417.417 0 000-.833zM5 7.083a2.083 2.083 0 114.167 0 2.083 2.083 0 01-4.167 0z"
        fill={color}
      />
    </svg>
  );
};

Picture.displayName = "Picture";
